import React from 'react'

import { Title } from '@acorns/web-components'
import styled from 'styled-components'

import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'

import acorns404 from './acorns404.svg'

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
`

const StyledTitle = styled(Title)`
  margin-bottom: 20px;
  text-align: center;
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 500px;
    margin: auto;
    margin-bottom: 20px;
  }
  @media (max-width: 500px) {
    width: 320px;
    margin: auto;
    margin-bottom: 20px;
  }
`

const StyledImage = styled.img`
  margin-bottom: 40px;
  @media (max-width: ${theme.breakpoints.sm}px) {
    width: 280px;
    margin: auto;
    margin-bottom: 40px;
  }
`

export const ErrorState = () => (
  <Container data-testid={TestIDs.ERROR_STATE.CONTAINER}>
    <StyledImage src={acorns404} alt="acorns404" />
    <StyledTitle bold>
      We are sorry, an error has occurred. Our technical team is looking into this.
    </StyledTitle>
  </Container>
)
